var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('v-btn',{staticStyle:{"color":"lightgray","border":"1px solid lightgray"},attrs:{"text":"","outlined":""},on:{"click":_vm.payWithRave}},[_vm._v(" Make Payment ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }